import React, { useEffect } from 'react';
import { getAuth } from 'firebase/auth';

const MobileRedirect = () => {
  useEffect(() => {
    const sendTokenToApp = async () => {
      const auth = getAuth();
      const user = auth.currentUser;
      
      if (user) {
        const token = await user.getIdToken();
        
        // Salvează token-ul în localStorage pentru aplicația mobilă
        localStorage.setItem('mobile_auth_token', token);
        
        // Încearcă să deschidă aplicația mobilă
        try {
          window.location.href = `catalogelectronic://auth?token=${token}`;
        } catch (error) {
          console.log('URL scheme failed, showing manual instructions');
        }
        
        // Afișează instrucțiuni manuale după 3 secunde
        setTimeout(() => {
          const instructions = document.getElementById('manual-instructions');
          if (instructions) {
            instructions.style.display = 'block';
          }
        }, 3000);
      } else {
        // Redirectează la login
        window.location.href = '/?mobile=true';
      }
    };
    
    sendTokenToApp();
  }, []);

  return (
    <div style={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      height: '100vh',
      flexDirection: 'column'
    }}>
      <h2>✅ Autentificare reușită!</h2>
      <p>Te redirectăm înapoi la aplicația mobilă...</p>
      <div style={{ marginTop: '20px' }}>
        <div className="spinner" style={{
          border: '4px solid #f3f3f3',
          borderTop: '4px solid #3498db',
          borderRadius: '50%',
          width: '40px',
          height: '40px',
          animation: 'spin 2s linear infinite',
          margin: '0 auto'
        }}></div>
      </div>
      
      <div id="manual-instructions" style={{ display: 'none', marginTop: '30px', textAlign: 'center' }}>
        <h3>Aplicația nu s-a deschis automat?</h3>
        <p>Întoarce-te la aplicația mobilă și reîncearcă.</p>
        <button 
          onClick={() => window.location.href = 'catalogelectronic://auth'}
          style={{
            padding: '10px 20px',
            backgroundColor: '#4285f4',
            color: 'white',
            border: 'none',
            borderRadius: '5px',
            fontSize: '16px'
          }}
        >
          Deschide aplicația mobilă
        </button>
      </div>
      
      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
};

export default MobileRedirect;